import { render, staticRenderFns } from "./CapNhat.vue?vue&type=template&id=7bdd2ecc&scoped=true"
import script from "./CapNhat.vue?vue&type=script&lang=js"
export * from "./CapNhat.vue?vue&type=script&lang=js"
import style0 from "./CapNhat.vue?vue&type=style&index=0&id=7bdd2ecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdd2ecc",
  null
  
)

export default component.exports